<template>
  <div>
    <services
        v-model="booking.services"
        :from="itemType"
        :item-type='itemType'
        :item-id="(allObject.event || {}).booking_id ?? (allObject.event || {}).inquiryId"
        :gift-status="allObject.gift_card"
        :company-id="allObject.company.company_id"
        :currency='currency'
        :date-format="dateFormat"
        :logged-user="allObject.loggedUser"
        :time-format="timeFormat">
    </services>
    <booking-pricing :booking="booking" :currency='currency' :booking-summary="booking.summary"
                     :consider-booking-min-price='allObject.consider_booking_min_price'
                     :voucher-value='allObject.voucher' :item-id='booking.booking_id' class="booking-pricing">
    </booking-pricing>
  </div>

</template>

<script>

export default {
    name: 'ViewBookingForm',
    props: {
        currency: null,
        bookingSummaryProp: {},
        dateFormat: null,
        timeFormat: null,
        businessTypeAllProp: null,
        descriptionProp: null,
        allObject: {
            type:Object
        },
        hasInquiryIdAsUrlParam: null,

    },
    computed: {
        itemType() {
            if ((this.allObject.event || {}).booking_id)
                return 'booking'
            else if ((this.allObject.event || {}).inquiry_id)
                return 'inquiry'
            else
                return null
        }
    },
    data() {
        return {
            booking: {
                inquiryId: (this.allObject.event || {}).inquiry_id ?? null,
                toEstimate: this.allObject.toEstimate ??0,
                toInvoice: this.allObject.toEstimate??0,
                isProducts: this.allObject.isProducts??0,
                previousStatus: (this.allObject.event || {}).status_id ?? 3,
                referral: "add" ?? null,
                voucherId: (this.allObject.voucher || {}).voucher_id ?? null,
                bookingStatus: (this.allObject.event || {}).status ?? null,
                summary: this.bookingSummaryProp ?? {},
                id: (this.allObject.event || {}).booking_id,
                forms: [],
                services: [],
                description: (this.allObject.event || {}).description ?? null,
                ownerId: (this.allObject.event || {}).created_by ?? null,
                tradingId: (this.allObject.event || {}).trading_name_id ?? null,
                sourceId: (this.allObject.event || {}).source_id ?? null,
                bookingLocationData:(this.allObject || {}).bookingAddress ?? {},
                cancellationFee: (this.allObject.event || {}).cancellation_fee ?? null,
                callOutFee: (this.allObject.event || {}).call_out_fee ?? null,
                customer: {
                    customer_id: (this.allObject.event || {}).customer_id ?? null,
                    customer_name: (this.allObject.event || {}).customer_name ?? null,
                    properties: []
                },
            },
        }
    },
    methods: {

    },
    mounted() {

    }
}

</script>

<style scoped>

.booking-pricing-ibox {
    border: none;
    padding-top: 0;
}

@import "tom-select/dist/css/tom-select.min.css";
@import "tom-select/dist/css/tom-select.bootstrap5.min.css";
</style>